import { useEffect } from "react"
import { useRoutes, useNavigate } from "react-router-dom"
import { Toaster } from "sonner"
import { IntlProvider } from "@/components/IntlProvider"
import { routes } from "./router"
import { setUnauthorizedHandler } from "@/lib/apiService"
import { useAuthStore } from "@/stores/authStore"

export default function App() {
	const element = useRoutes(routes)
	const navigate = useNavigate()
	const logout = useAuthStore((s) => s.logout)

	useEffect(() => {
		setUnauthorizedHandler(() => {
			logout()
			navigate("/login")
		})
	}, [logout, navigate])

	return (
		<IntlProvider>
			{element}
			<Toaster position="bottom-right" richColors />
		</IntlProvider>
	)
}
